<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t('message.Каналы') }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t('message.Главная') }}</router-link>
          </li>
          <li class="active breadcrumb-item">{{ $t('message.Каналы') }}</li>
        </ol>
      </div>
    </div>

    <div id="main-wrapper">
      <b-button
        :variant="'success'"
        class="mb-1 float-right"
        @click="addRow()"
      >{{ $t('message.Добавить_канал') }}</b-button>
      <b-table
        id="device-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filters"
        :sort-by.sync="sortBy"
      >
        <template slot="HEAD_id" slot-scope="data">
          <b-form-group label="ID">
            <b-form-input
              @click.native.stop
              size="sm"
              :readonly="isBusy"
              v-debounce="1000"
              :value="innerFilter.id"
              @change.native="innerFilter.id = $event.target.value"
              style="width:50px;"
            ></b-form-input>
          </b-form-group>
        </template>
        
        <template slot="HEAD_image" slot-scope="data"></template>

        <template slot="HEAD_name" slot-scope="data">
          <b-form-group label="Name">
            <b-form-input
              @click.native.stop
              size="sm"
              :readonly="isBusy"
              v-debounce="1000"
              :value="innerFilter.name"
              @change.native="innerFilter.name = $event.target.value"
              style="width:300px;"
            ></b-form-input>
          </b-form-group>
        </template>

        <template slot="HEAD_comment" slot-scope="data">
          <b-form-group label="Comment">
            <b-form-input
              @click.native.stop
              size="sm"
              :readonly="isBusy"
              v-debounce="1000"
              :value="innerFilter.comment"
              @change.native="innerFilter.comment = $event.target.value"
              style="width:100px;"
            ></b-form-input>
          </b-form-group>
        </template>

        <template slot="sort_order" slot-scope="row">
          <div
            v-show="order_update_id != row.item.id"
            @click.stop="updateOrder(row.item)"
            style="width:65px;cursor:text;text-align:center;border-bottom: 1px dotted #999;"
          >{{row.item.sort_order}}</div>
          <input
            v-show="order_update_id == row.item.id"
            v-focus="order_update_id == row.item.id"
            v-model="row.item.sort_order"
            v-on:blur="saveOrder(row.item)"
            @keyup.enter="saveOrder(row.item)"
            style="width:65px"
          />
        </template>

        <template slot="actions" slot-scope="row">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button size="sm" @click.stop="deleteRow(row.item, row.index, $event.target)">
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
        <template slot="status" slot-scope="row">
          <span style="font-size: 1em">
            <i
              class="fa fa-power-off"
              :class="row.item.enabled ? 'text-success' : 'text-danger'"
              :title="row.item.enabled ? 'enabled' : 'disabled'"
              aria-hidden="true"
            ></i>
            <i
              class="fab fa-internet-explorer"
              :class="row.item.public ? 'text-success' : 'text-danger'"
              :title="row.item.public ? 'visible on online player' : 'hidden from online player'"
              aria-hidden="true"
            ></i>
          </span>
          <span style="font-size: 1.3em">
            <i
              class="fab fa-apple"
              :class="row.item.market_accessable ? 'text-success' : 'text-danger'"
              :title="row.item.market_accessable ? 'visible on markets' : 'hidden from markets'"
              aria-hidden="true"
            ></i>
          </span>
        </template>
        <template slot="packages" slot-scope="data">
          <b-badge class="mr-1" v-for="pack in data.item.packages" :key="pack.id">{{pack.name}}</b-badge>
        </template>
        <template slot="image_url" slot-scope="data">
          <img :src="data.item.image_url" :width="64" />
        </template>
        <template slot="categories" slot-scope="data">
          <b-badge class="mr-1" v-for="pack in data.item.categories" :key="pack.id">{{pack.name}}</b-badge>
        </template>
        <template slot="programs" slot-scope="data">
          <b-button
            v-if="data.item.epg_channel && data.item.epg_channel.id"
            :variant="'success'"
            class="mb-1 float-left"
            @click="showProgram(data.item)"
          >{{ $t('message.Смотреть_программу') }}</b-button>
        </template>
        <template slot="name" slot-scope="row">
          {{row.item.name}}
          <span v-if="row.item.comment" class="text-muted">({{row.item.comment}})</span>
          <br>
          <b-button
            :variant="'success'"
            class="mb-1 float-left"
            @click="showStream(row.item)"
          >{{ $t('message.Посмотреть_потоки') }}</b-button>          
        </template>
      </b-table>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"></b-pagination>

      <b-modal
        id="modalInfo"
        @hide="resetModal"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Каналы_-_Редактирование')"
        modal-ok
        modal-cancel
        @ok="handleOk"
      >
        <ChannelForm :model="channelModel"></ChannelForm>
      </b-modal>
      <b-modal
        id="modalProgram"
        @hide="resetProgramModal"
        :ok-title="$t('message.Закрыть')"
        :title="$t('message.Программа_передач_-_Просмотр')"
        ok-only
        size="lg"
      >
        <ProgramForm :model="channelModel"></ProgramForm>
      </b-modal>
        <!-- scrollable  -->

      <b-modal
        id="modalStream"
        :ok-title="$t('message.Закрыть')"
        :title="$t('message.Потоки')"
        ok-only
        size="xl"
      >      
        <Streams :model="channelModel"></Streams>
      </b-modal>
    </div>
  </div>
</template>

<script>
import ChannelForm from "./ChannelForm";
import StreamForm from "./StreamForm";
import ProgramForm from "./ProgramForm";
import Streams from "./Streams";
import Vue from "vue";
import debounce from "./stolencrap/index";
import { focus } from "vue-focus";

export default {
  name: "Channels",
  components: {
    ChannelForm,
    StreamForm,
    ProgramForm,
    Streams
  },
  data() {
    return {
      isBusy: false,
      sortBy: "sort_order",
      fields: [
        { key: "id", sortable: true },
        { key: "image_url", sortable: false },
        { key: "name", sortable: true, thStyle: "width:50%;" },
        { key: "status", sortable: false, thStyle: "min-width:100px;" },
        { key: "sort_order", sortable: true },
        { key: "programs", sortable: false },
        { key: "packages", sortable: false },
        { key: "categories", sortable: false },
        { key: "actions", label: "", tdClass: "actions" }
      ],
      channelModel: {},
      streams: [],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      order_update_id: null,
      innerFilter: {
        id: "",
        name: "",
        comment: ""
      }
    };
  },
  computed: {
    filters: function() {
      this.currentPage = 1;

      return JSON.stringify(this.innerFilter);
    }
  },
  methods: {
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      //console.log(ctx)
      let promise = this.$noname.get("channels", { params: ctx });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false

          return items;
        })
        .catch(this.$noname.HandleError);
    },
    editRow(item, index, button) {
      if (item.epg_channel == null) {
        item.epg_channel = {};
      }
      if (item.epg_channel.id == null || item.epg_channel.id == undefined) {
        item.epg_channel = {};
      }

      this.channelModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    showStream(item) {
      this.channelModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalStream");
    },    
    showProgram(item) {
      this.channelModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalProgram");
    },
    deleteRow(item, index, button) {
      this.$dialog
        .confirm(this.$i18n.t("message.Действительно_удалить_канал?"))
        .then(response => {
          this.$noname
            .delete("channels", item.id)
            .then(response => {
              this.$root.$emit("bv::refresh::table", "device-table");
              Vue.notify({
                group: "notify",
                text: this.$i18n.t("message.Запись_успешно_удалена"),
                type: "success"
              });

              //window.location.href = redirectUrl
            })
            .catch(error => {
              Vue.notify({
                group: "notify",
                text:
                  this.$i18n.t("message.Ошибка_удаления_записи") +
                  ":<br>" +
                  error,
                type: "error"
              });
            });
        });
    },
    addRow() {
      this.channelModel = {};
      this.$root.$emit("bv::show::modal", "modalInfo");
    },
    updateOrder(channel) {
      this.order_update_id = channel.id;
    },
    saveOrder(channel) {
      if (channel.sort_order === "" || isNaN(channel.sort_order)) {
        Vue.notify({
          group: "notify",
          text: this.$i18n.t("message.Неверное_значение"),
          type: "warning"
        });
        return;
      }

      this.$noname
        .patch("channels", channel.id, { sort_order: channel.sort_order })
        .then(response => {
          this.order_update_id = null;
          this.$root.$emit("bv::refresh::table", "device-table");
          Vue.notify({
            group: "notify",
            text: this.$i18n.t("message.Порядок_сохранён"),
            type: "success"
          });
        })
        .catch(error => {
          Vue.notify({
            group: "notify",
            text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
            type: "error"
          });
        });
    },
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();

      if (
        this.channelModel.image &&
        this.channelModel.image.indexOf("data:image") == -1
      ) {
        this.channelModel.image = null;
      }

      if (this.channelModel.id > 0) {
        this.$noname
          .patch("channels", this.channelModel.id, this.channelModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      } else {
        this.$noname
          .post("channels", this.channelModel)
          .then(response => {
            console.log(response);
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text:
                Vue.$t("message.Ошибка_сохранения") +
                ":<br>" +
                error +
                "<br>" +
                error.response.data.message,
              type: "error"
            });
          });
      }
    },
    resetModal() {
      // this.deviceModel = {}
    },
    resetProgramModal() {
      // this.deviceModel = {}
    },
    getLogos() {}
  },
  watch: {
    innerFilters: {
      handler: function() {
        return this.innerFilter;
      },
      deep: true
    }
  },
  directives: { debounce, focus }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/Channels.vue